import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import type { useTokenBelongsToUser_anyCard } from './__generated__/useTokenBelongsToUser.graphql.ts';

export const useTokenBelongsToUser = () => {
  const { currentUser } = useCurrentUserContext();

  return (card: useTokenBelongsToUser_anyCard) => {
    return card.user?.slug === currentUser?.slug;
  };
};

useTokenBelongsToUser.fragments = {
  anyCard: gql`
    fragment useTokenBelongsToUser_anyCard on AnyCardInterface {
      slug
      user {
        slug
      }
    }
  ` as TypedDocumentNode<useTokenBelongsToUser_anyCard>,
};
